import React from "react";
import { useNavigate } from "react-router-dom";
function BackLink() {
  const navigate = useNavigate();
  return (
    <div className="paddingBt-16">
        <button 
          className="back-button body text-decoration-none grey-light" 
          onClick={() => navigate(-1)}
        >
          <img src="/images/arrown-left.svg" alt="Back" />
          Retour
        </button>
    </div>
  );
}

export default BackLink;
